import * as THREE from 'three';
import {
  CARD1Web
} from '../CoordUtils.js';

import {BaseDrawer} from "@/drawings3D/modelDrawing/BaseDrawer"

export class MedialDividerDrawer extends BaseDrawer {
  constructor(medialDivider, sceneManager, stepFactor){
    super(sceneManager, medialDivider.startStake, medialDivider.endStake, medialDivider.roadStakes);
    this.medialDivider = medialDivider;
    
    this.medialDividerMaterial = new THREE.MeshPhongMaterial({
      map: new THREE.TextureLoader().load("/static/bimroad/textures/concreteSurface.jpg")
  });
    this.stepFactor = stepFactor;
   
    // this.lerpAlpha = this.medialDivider.width / this.roadWidth;
    // this.leftBasePt = new THREE.Vector3();
    // this.rightBasePt = new THREE.Vector3();
    // this.leftBasePt.lerpVectors(this.startStakeCenterPos, this.leftBasePos, lerpAlpha);
    // this.rightBasePt.lerpVectors(this.startStakeCenterPos, this.rightBasePos, lerpAlpha);  
  }

  draw(){
        var curveLine = new Array();
        curveLine.push(this.startStakeCenterPos);
        for(var i = 1; i < this.roadStakes.length - 1; i++){
          curveLine.push(this.roadStakes[i].baseCenter);
        }

        curveLine.push(this.endStakeCenterPos);
        var closedSpline = new THREE.CatmullRomCurve3(curveLine);

        closedSpline.curveType = 'catmullrom';
        closedSpline.closed = false;

        var extrudeSettings = {
          steps: this.lastStakeIndex * this.stepFactor,
          bevelEnabled: false,
          extrudePath: closedSpline
        };

        //在起点构建shape

        var pts = [];
        pts.push(new THREE.Vector2( 0, -this.medialDivider.width / 2));
        pts.push(new THREE.Vector2( -0.3, -this.medialDivider.width / 2 + 0.3));
        pts.push(new THREE.Vector2( -this.medialDivider.height, -this.medialDivider.width / 2 + 0.3));
        pts.push(new THREE.Vector2( -this.medialDivider.height, this.medialDivider.width / 2 - 0.3));
        pts.push(new THREE.Vector2( -0.3, this.medialDivider.width / 2 - 0.3));
        pts.push(new THREE.Vector2( 0, this.medialDivider.width / 2));
        var shape = new THREE.Shape( pts);
        var geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings );
        
        //利用第一个shape点的三维坐标和轴线点的差，因为轴线和第一个点应该基本是平行于y轴，因此y基本为0，
        //如果不是平行，则可以知道翻转了，根据反转的x正负和y的大小，可以判断是往哪个方向翻转
        var posPts = geometry.attributes.position.array;
        var firstPt = new THREE.Vector3(posPts[0], posPts[1], posPts[2]);
        firstPt.sub(this.startStakeCenterPos);
        if (firstPt.y > 0.1){
            //这里可以改进，不需要重新生成geometry，只需要对geometry绕着轴线的向量旋转即可
            geometry = this.getRotatedGeometry(extrudeSettings);
        }
        //debug purpose
        //  var geometry1 = new THREE.SphereGeometry( 0.1, 10, 10 );
        //  var material1 = new THREE.MeshBasicMaterial( {color: 0xff0000} );
        //  var sphere1 = new THREE.Mesh( geometry1, material1 );
        //  this.sceneManager.scene.add( sphere1 );
        //  sphere1.position.copy(firstPt);

        this.mesh = new THREE.Mesh( geometry, this.medialDividerMaterial );
        return this.mesh;
  }
  
  getRotatedGeometry(extrudeSettings){
    var pts = [];
        pts.push(new THREE.Vector2( -this.medialDivider.width / 2, 0));
        pts.push(new THREE.Vector2( -this.medialDivider.width / 2 + 0.3, 0.3));
        pts.push(new THREE.Vector2( -this.medialDivider.width / 2 + 0.3, this.medialDivider.height));
        pts.push(new THREE.Vector2( this.medialDivider.width / 2 - 0.3, this.medialDivider.height));
        pts.push(new THREE.Vector2( this.medialDivider.width / 2 - 0.3, 0.3));
        pts.push(new THREE.Vector2( this.medialDivider.width / 2, 0));
        var shape = new THREE.Shape( pts);
        var geometry = new THREE.ExtrudeBufferGeometry( shape, extrudeSettings );
        return geometry;
    }
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/MedialDividerDrawer.js